export default __webpack_public_path__ + "static/CloudPouchLogo-dee88dfdb9a55d14c88ea1eb0d10adce.png";